export default __webpack_public_path__ + "static/urban-dfbed17d711b089d03711d156d102785.png";